import React from "react";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { useLoginMarketingConfig } from "../../hooks/useLoginMarketingConfig";
import { DEFAULT_LOGIN_MARKETING_CONFIG } from "../../services/api/loginMarketingConfig";
import {
  WelcomeSection,
  WelcomeInner,
  WelcomeTagline,
  HeroTitle,
  WelcomeHello,
  WelcomeAccent,
  WelcomeRule,
  WelcomeHeading,
  WelcomeDescription,
  HeroImage,
  FeatureRow,
  FeatureItem,
  FeatureIcon,
  FeatureLabel,
  TrustedFooter,
} from "./DashboardAuthStyles";

const FEATURES: Array<{
  label: string;
  tone: "teal" | "coral" | "blue" | "mint";
  Icon: typeof ArticleOutlinedIcon;
}> = [
  { label: "Notices", tone: "teal", Icon: ArticleOutlinedIcon },
  { label: "Events", tone: "coral", Icon: CalendarMonthOutlinedIcon },
  { label: "Drive", tone: "blue", Icon: FolderOutlinedIcon },
  { label: "Circles", tone: "mint", Icon: GroupsOutlinedIcon },
];

const AuthWelcomePanel: React.FC = () => {
  const { data } = useLoginMarketingConfig();
  const heading = data?.heading ?? DEFAULT_LOGIN_MARKETING_CONFIG.heading;
  const description =
    data?.description ?? DEFAULT_LOGIN_MARKETING_CONFIG.description;
  const heroImageUrl =
    data?.heroImageUrl ?? DEFAULT_LOGIN_MARKETING_CONFIG.heroImageUrl;

  return (
    <WelcomeSection>
      <WelcomeTagline>
        For the moments
        <br />
        that matter.
      </WelcomeTagline>
      <WelcomeInner>
        <HeroTitle>
          <WelcomeHello>Hello</WelcomeHello>
          <WelcomeAccent>Noticeboard</WelcomeAccent>
        </HeroTitle>
        <WelcomeRule aria-hidden="true" />
        <WelcomeHeading>{heading}</WelcomeHeading>
        <WelcomeDescription>{description}</WelcomeDescription>
        <HeroImage
          src={heroImageUrl}
          alt="Noticeboard dashboard on laptop and phone"
        />
        <FeatureRow>
          {FEATURES.map(({ label, tone, Icon }) => (
            <FeatureItem key={label}>
              <FeatureIcon $tone={tone} aria-hidden="true">
                <Icon fontSize="small" />
              </FeatureIcon>
              <FeatureLabel>{label}</FeatureLabel>
            </FeatureItem>
          ))}
        </FeatureRow>
        <TrustedFooter>
          <svg viewBox="0 0 120 36" fill="none" aria-hidden="true">
            <path
              d="M4 22 C22 6, 38 32, 56 18 C70 6, 82 24, 96 16"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
            />
            <path
              d="M98 12.5 C98 9.4, 100.5 7.2, 103.2 7.2 C104.8 7.2, 106.2 8.1, 106.8 9.6 C107.4 8.1, 108.8 7.2, 110.4 7.2 C113.1 7.2, 115.6 9.4, 115.6 12.5 C115.6 17.8, 106.8 24.2, 106.8 24.2 C106.8 24.2, 98 17.8, 98 12.5 Z"
              fill="currentColor"
            />
          </svg>
          <span>
            Trusted by schools and communities
            <br />
            across South Africa.
          </span>
        </TrustedFooter>
      </WelcomeInner>
    </WelcomeSection>
  );
};

export default AuthWelcomePanel;
